import { Injectable } from '@angular/core';
import * as globals from '../globals';

@Injectable()
export class ProjectDataService {

  private forceupdatebool = false;
  private currentSearchedTerm: string;

  constructor() { }

  setForceUpdateBool(forceupdateboolvalue: boolean) {
    this.forceupdatebool = forceupdateboolvalue;
  }

  getForceUpdateBool() {
    return this.forceupdatebool;
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/dataservice.service.ts